import { render, staticRenderFns } from "./businessTab.vue?vue&type=template&id=edff40c0"
import script from "./businessTab.vue?vue&type=script&lang=js"
export * from "./businessTab.vue?vue&type=script&lang=js"
import style0 from "./businessTab.vue?vue&type=style&index=0&id=edff40c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports